import { QuestionBase } from './question-base.model';

export class LabelQuestion extends QuestionBase<string> {
    controlType = 'label';
    type: string;
    name: string;
    popover: string;
    format: string;
    conditions: any = [];
    class_conditions: any;
    grid_color_text: any;
    view_required: boolean;
    visible: boolean = true;
    flag: any;
    sortable: boolean;
    conversion:any;
    required:boolean=false;
    show_popover:boolean=false;
    currentStage:any;
    image_conditions: any;
    constructor(options: {} = {}) {
        super(options);
        this.type = options['type'] || '';
        this.name = options['name'] || '';
        this.popover = options['popover'] || '';
        this.format = options['format'] || "";
        this.conditions = options['conditions'];
        this.visible = options['visible'] != undefined ? options['visible'] : true;
        this.class_conditions = options['class_conditions'] == undefined ? false : options['class_conditions'];
        this.grid_color_text = options['grid_color_text'] == undefined ? false : options['grid_color_text'];
        this.view_required = options['view_required'] || false;
        this.flag = options['flag'] || false;
        this.sortable = options['sortable'] == undefined ? false : options['sortable'];
        this.conversion = options['conversion'] || undefined;
        this.required = options['required'] || false;
        this.show_popover = options['show_popover'] != undefined ? options['show_popover'] : false;
        this.currentStage = options['currentStage'] || undefined;
        this.image_conditions = options['image_conditions'] == undefined ? false : options['image_conditions'];
    }
}